import oRequest from '@/libsV2/request.js';
import store from '@/store/store';

const getData = (url, data) => {
    return oRequest.getData(url, data).then(res => {
        return res.data
    })
}

export const getEvaluationList = (data) => {
    return getData('discuss.index/completed_list', data)
}

export const getEvaluationPosteradd = (data) => {
    return getData('discuss.index/posteradd', data)
}

export const getEvaluationCount = (data) => {
    return getData('discuss.index/discuss_count', data)
}

export const getProjectInfo = (data) => {
    return getData('project.discuss/info', data)
}

export const getProjectList = (data) => {
    return getData('project.discuss/lists', data)
}

//项目uuid转化项目3.0id
export const v2tov3id = (data) => {
    return oRequest.getData('project/v3/info/v2tov3id', data)
}
